<template>
  <div class="pt-4 px-2">
    <div class="flex justify-center mb-4 relative">
      <a class="absolute flex top-4 left-0 text-link text-sm" @click="$emit('close')">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_back') }}</span>
      </a>
      <h1 class="section-title">{{ $t('tour_genre_title') }}</h1>
    </div>
    <div class="bg-white border border-section_border border-b-0 rounded">
      <ul>
        <li v-for="genre in genres" v-bind:key="genre.id">
          <div @click="$emit('selectGenre', genre)" class="flex items-center p-4 pr-2 border-b">
            <span class="text-link font-bold flex-grow">{{ genre.name }}</span>
            <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" class="text-body text-opacity-50"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
          </div>
          <ul v-if="genre.children">
            <li v-for="child in genre.children" v-bind:key="child.id" class="p-3  pr-2 border-b text-link">
              <div @click="$emit('selectGenre', child)" class="flex items-center pl-4">
                <span class="flex-grow">{{ child.name }}</span>
                <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" class="text-body text-opacity-50"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      genres: 'genres/getAllForList'
    })
  }
}
</script>
